import { daysFormat, getDayInterval } from '@/filters'
import {
  getDistinct,
  getSameAttribute,
  removeNull,
  sortArray
} from '@/utils/handleData'
import { isEnterpriseDirectValue, isTzInspectionSession } from '@/utils/bidLevelActions.js'

function carEntryParts(item) {
  return {
    code: String((item && (item.carCode || item.carcode)) || '').trim(),
    name: String((item && (item.carName || item.carname)) || '').trim(),
    owner: String((item && (item.ownerName || item.ownername)) || '').trim()
  }
}

function formatCarEntryLabel(item, labelKey) {
  const parts = carEntryParts(item)
  if (labelKey === 'carName') return parts.name || parts.code || ''
  return parts.code || parts.name || ''
}

function formatCarEntryDesc(item, labelKey) {
  const parts = carEntryParts(item)
  if (labelKey === 'carName') {
    return [parts.code && parts.code !== parts.name ? parts.code : '', parts.owner]
      .filter(Boolean)
      .join('　')
  }
  return [
    parts.name && parts.name !== parts.code ? parts.name : '',
    parts.owner
  ]
    .filter(Boolean)
    .join('　')
}

function licenseUidList(val) {
  if (!val) return []
  if (Array.isArray(val)) {
    return val
      .map((item) => {
        if (!item) return ''
        if (typeof item === 'string') return item
        return item.uid || ''
      })
      .filter(Boolean)
  }
  return [val]
}

function attachVehicleLicense(info, commit, rootState) {
  const data = info || {}
  data.fileLists = data.fileLists || {}
  const uids = licenseUidList(data.vehicleLicense)
  data.vehicleLicense = uids
  data.fileLists.vehicleLicense = []
  if (uids.length) {
    commit('pictureSet', { key: 'vehicleLicense', value: uids }, { root: true })
    data.fileLists.vehicleLicense = rootState.pictures.vehicleLicense
  }
  return data
}

function attachPolicyImages(list, commit, rootState) {
  const items = list || []
  items.forEach((item) => {
    item.fileLists = {
      policyImage: []
    }
    if (item.policyImage && item.policyImage.length) {
      commit(
        'pictureSet',
        { key: 'policyImage', value: item.policyImage },
        { root: true }
      )
      item.fileLists.policyImage = rootState.pictures.policyImage
    }
    item.srcList = getSameAttribute(item.fileLists.policyImage, 'url').values
    item.policyImageInfo =
      item.policyImage && item.policyImage.length
        ? item.policyImage.length + '张保单图片'
        : '无保单图片'
  })
  return items
}

function attachMaintainDocs(list, commit, rootState) {
  const items = list || []
  items.forEach((item) => {
    item.fileLists = {
      maintenanceDocument: []
    }
    if (item.maintenanceDocument && item.maintenanceDocument.length) {
      commit(
        'pictureSet',
        { key: 'maintenanceDocument', value: item.maintenanceDocument },
        { root: true }
      )
      item.fileLists.maintenanceDocument = rootState.pictures.maintenanceDocument
    }
    item.srcList = getSameAttribute(
      item.fileLists.maintenanceDocument,
      'url'
    ).values
    item.maintenanceDocumentInfo =
      item.maintenanceDocument && item.maintenanceDocument.length
        ? item.maintenanceDocument.length + '张维修保养单据'
        : '无维修保养单据'
    item.nextMaintainDate = item.nextMaintainDate
      ? daysFormat(item.nextMaintainDate)
      : ''
  })
  return items
}

export default {
  namespaced: true,
  state: {
    officialCarList: [], // 工程用车列表
    officialCarTotal: 0,
    carList: [],
    officialCars: [], // 模糊检索工程用车
    officialCarInfo: {}, // 工程用车信息
    carsList: {}, //车辆库列表
    carInfo: {} // 车辆基础信息
  },
  getters: {
    carLists: (state, getters, rootState, rootGetters) => {
      var carLists = JSON.parse(JSON.stringify(state.officialCarList))
      carLists.forEach((item, index) => {
        item.dayInterval =
          typeof item.dayInterval === 'number' ? item.dayInterval : Infinity
        const device = state.carList.find((car) => {
          return car.carPlate === item.carCode
        })
        if (device) {
          item.monitoringState = rootState.dictionarys.carState.find((s) => {
            return s.value === device.state
          }).label
          item.position = [parseFloat(device.glng), parseFloat(device.glat)]
          const carUsage = rootState.dictionarys.carUsage.find(
            (car) => item.carUsage === car.label
          )
          if (carUsage) {
            item.iconfont = carUsage.iconfont
            item.iconColor = carUsage.iconColor
          }
          item.contentType =
            device.state === '7' || device.state === '8' ? 'water' : 'circle'
          item.contentColor = item.contentType === 'water' ? '' : '#fd0e024a'
          item.markerLabel = {
            content:
              device.state === '7' || device.state === '8'
                ? item.carCode + '\xa0\xa0' + device.speed + 'km/h'
                : ''
          }
          carLists[index] = Object.assign({}, item, device)
        } else {
          item.monitoringState =
            item.monitoringInfo === '无监控设备' ? '无监控' : '离线-报警'
          item.state = item.monitoringInfo === '无监控设备' ? 0 : 4
        }
      })
      if (isTzInspectionSession(rootGetters)) {
        return carLists
      }
      carLists =
        sortArray(
              carLists,
              ['exit', 'monitoringState', 'isExpired'],
              [
                '',
                [
                  '在线-行驶',
                  '在线-行驶-报警',
                  '在线-无效定位',
                  '在线-停车-ACC开',
                  '在线-停车-ACC开-报警',
                  '在线-停车-ACC关',
                  '在线-停车-ACC关-报警',
                  '离线',
                  '离线-报警',
                  '无监控'
                ],
                ['未备案', '已过期', '未过期']
              ]
            )
      return carLists
    },
    noExitCar: (state, getters) => {
      return getters.carLists.filter((item) => {
        return !item.exit
      })
    },
    hasMonitor: (state, getters) => {
      return getters.noExitCar.filter((item) => {
        return item.monitoringInfo !== '无监控设备'
      })
    },
    onlineCar: (state, getters) => {
      return getters.hasMonitor.filter((item) => {
        return item.state === '7' || item.state === '8'
      })
    }
  },
  actions: {
    // 新增工程用车信息
    async addOfficialCar({ dispatch }, data) {
      const list = Array.isArray(data) ? data : data ? [data] : []
      list.forEach((item) => {
        if (!item) return
        if (!item.carCode && item.carName) item.carCode = item.carName
        if (!item.carName && item.carCode) item.carName = item.carCode
        item.vehicleLicense = licenseUidList(item.vehicleLicense)
      })
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/car/info',
          data: data,
          msg: '新增设备信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除工程用车信息
    async deleteOfficialCar({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/car/info',
          data: { uid: uid },
          msg: '删除车辆信息成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑工程用车信息
    async editOfficialCar({ dispatch }, data) {
      if (data) {
        data.vehicleLicense = licenseUidList(data.vehicleLicense)
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/car/info',
          data: data,
          msg: '编辑设备信息成功'
        },
        { root: true }
      )
      return res
    },
    // 获取车辆信息列表
    async getCarsList({ rootState, commit, dispatch, rootGetters }, data) {
      const isOwnLib = rootState.currentStep.theme === 'ownEquipment'
      const queryKey = isOwnLib ? 'ownEquipment' : 'mechanicalEquipment'
      const pageQuery = rootState.queryValues[queryKey] || {}
      var queryValues = {
        query:
          (data && data.query) ||
          pageQuery.query ||
          '',
        ownerName:
          (data && data.ownerName) ||
          pageQuery.ownerName ||
          (isOwnLib ? rootGetters['user/orgName'] : ''),
        limit:
          (data && data.limit) ||
          rootState.limit[queryKey] ||
          10,
        page:
          (data && data.page) ||
          rootState.page[queryKey] ||
          1
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/car/lists',
          data: queryValues
        },
        { root: true }
      )
      var carsList = res.data ? res.data : {}
      carsList.result &&
        carsList.result.forEach((item) => {
          item.paramJson = item.paramJson ? item.paramJson : []
          item.paramJson.forEach((param) => {
            param.info =
              param.label + '：' + param.value + (param.unit ? param.unit : '')
          })
          item.paramJsonInfo = getSameAttribute(
            item.paramJson,
            'info',
            '；'
          ).joinString
          item.paramJsonInfo = item.paramJsonInfo ? item.paramJsonInfo : '/'
          item.carName = item.carName || item.carModel || item.carCode
          item.isExpired = !item.insuranceExpiryDate
            ? '未备案'
            : item.insuranceExpiryDate &&
              daysFormat(item.insuranceExpiryDate) < daysFormat(new Date())
            ? '已过期'
            : '未过期'
          item.insuranceExpiryDate = !item.insuranceExpiryDate
            ? '/'
            : daysFormat(item.insuranceExpiryDate)
          item.latestMaintainDate = !item.latestMaintainDate
            ? '/'
            : daysFormat(item.latestMaintainDate)
          item.nextMaintainDate = !item.nextMaintainDate
            ? '/'
            : daysFormat(item.nextMaintainDate)
        })
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'carsList',
          value: carsList
        },
        { root: true }
      )
      return carsList
    },
    async getOwnEquipmentAddForm({ dispatch, commit, rootState, rootGetters }) {
      const orgUid = rootState.user && rootState.user.orgValue
      const org = rootGetters['user/organization'] || {}
      let info =
        (rootState.enterprise && rootState.enterprise.enterpriseBaseInfo) || {}
      if (orgUid && info.uid !== orgUid) {
        const res = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/fixed/companyinfo/detail',
            data: { orgUid },
            noErrorMsg: true
          },
          { root: true }
        )
        const raw = res && res.data
        info = Array.isArray(raw) ? raw[0] || {} : raw || {}
        info.uid = orgUid
        info.name = info.orgName || info.name
        commit(
          'baseSet',
          {
            module: 'enterprise',
            key: 'enterpriseBaseInfo',
            value: info
          },
          { root: true }
        )
      }
      const pick = (...vals) => {
        for (let i = 0; i < vals.length; i++) {
          const val = vals[i]
          if (val !== undefined && val !== null && String(val).trim() !== '') {
            return String(val).trim()
          }
        }
        return ''
      }
      return {
        uid: '',
        carCode: '',
        carName: '',
        carModel: '',
        ownerName: pick(
          info.orgName,
          info.name,
          org.orgCode,
          org.orgName,
          rootGetters['user/orgName']
        ),
        ownerCardNum: pick(info.creditCode, info.creditcode),
        ownerPhone: pick(
          info.contactTel,
          info.contacttel,
          info.legalPersonTel,
          info.legalpersontel
        ),
        approvedPenson: null,
        paramJson: null,
        vehicleLicense: [],
        fileLists: {
          vehicleLicense: []
        }
      }
    },
    // 获取车辆信息
    async getOfficialCarInfo({ state, rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/car/infobyuid',
          data: { uid: uid ? uid : state.carInfo.uid }
        },
        { root: true }
      )
      var carInfo = res.data ? res.data : {}
      carInfo.paramJson = carInfo.paramJson ? carInfo.paramJson : []
      carInfo.paramJson.forEach((param, index) => {
        carInfo['key' + (index + 1)] = param.key
        carInfo['label' + (index + 1)] = param.label
        carInfo['value' + (index + 1)] = param.value
        carInfo['unit' + (index + 1)] = param.unit
        carInfo[param.key] = param.value
      })
      carInfo.fileLists = {
        vehicleLicense: []
      }
      attachVehicleLicense(carInfo, commit, rootState)
      carInfo.insuranceList = attachPolicyImages(
        carInfo.insuranceList,
        commit,
        rootState
      )
      carInfo.maintainList = attachMaintainDocs(
        carInfo.maintainList,
        commit,
        rootState
      )
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'carInfo',
          value: carInfo
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'insurance',
          key: 'insuranceList',
          value: carInfo.insuranceList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'maintenance',
          key: 'maintainList',
          value: carInfo.maintainList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'device',
          key: 'deviceList',
          value: carInfo.deviceList
        },
        { root: true }
      )
      return carInfo
    },
    // 通过车牌号或车主姓名查询已备案车辆
    async getOfficialCars({ commit, dispatch }, query) {
      const payload =
        query && typeof query === 'object' ? query : { query: query }
      const keyword = payload.query
      const labelKey = payload.labelKey || 'carCode'
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/car/info',
          data: { query: keyword }
        },
        { root: true }
      )
      var officialCars = res.data ? res.data : []
      const valueCounts = {}
      officialCars.forEach((item) => {
        item.carCode = item.carCode || item.carcode || ''
        item.carName = item.carName || item.carname || ''
        item.ownerName = item.ownerName || item.ownername || ''
        item.paramJson = item.paramJson ? item.paramJson : []
        if (Array.isArray(item.paramJson)) {
          item.paramJson.forEach((param) => {
            if (param && param.key) {
              item[param.key] = param.value
            }
          })
        }
        const selectValue =
          labelKey === 'carName'
            ? item.carName || item.carCode || item.uid
            : item.carCode || item.carName || item.uid
        valueCounts[selectValue] = (valueCounts[selectValue] || 0) + 1
        item._selectValue = selectValue
      })
      officialCars.forEach((item) => {
        item.label = formatCarEntryLabel(item, labelKey)
        item.optionDesc = formatCarEntryDesc(item, labelKey)
        item.value =
          valueCounts[item._selectValue] > 1 ? item.uid : item._selectValue
        delete item._selectValue
        item.isExpired = !item.insuranceExpiryDate
          ? '未备案'
          : item.insuranceExpiryDate &&
            item.insuranceExpiryDate < daysFormat(new Date())
          ? '已过期'
          : '未过期'
        let monitoringInfo = []
        item.monitoringInfo = item.monitoringInfo ? item.monitoringInfo : []
        item.monitoringInfo.forEach((device) => {
          monitoringInfo = monitoringInfo.concat(device.split())
        })
        item.monitoringInfo = monitoringInfo.length
          ? getDistinct(monitoringInfo).join('、')
          : '无监控设备'
      })
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'officialCars',
          value: officialCars
        },
        { root: true }
      )
    },
    // 工程用车进场
    async officialCarEnter({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/car/entry',
          data: data,
          msg: data.isCheck ? '车辆检验信息填报成功' : '施工机械进场成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑工程用车进场信息
    async editOfficialCarEnter({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/car/entry',
          data: data,
          msg: data.isCheck
            ? '车辆检验信息编辑成功'
            : '编辑施工机械进场信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除工程用车进场信息
    async deleteOfficialCarEnter({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/car/entry',
          data: { uid: uid },
          msg: '删除信息成功'
        },
        { root: true }
      )
      return res
    },
    // 获取工程用车进场信息列表
    async getOfficialCarList(
      { state, rootState, rootGetters, commit, dispatch },
      data
    ) {
      const tabLabel =
        rootState.currentTab && rootState.currentTab.label
          ? rootState.currentTab.label
          : ''
      const isFixedList =
        rootState.currentStep.step === 'fixedEquipmentList' ||
        tabLabel === '固定机械' ||
        tabLabel === '固定设备'
      const queryKey = isFixedList ? 'fixedEquipment' : 'officialCar'
      const pageQuery = rootState.queryValues[queryKey] || {}
      const tz = isTzInspectionSession(rootGetters)
      const isDeviceListPage =
        rootState.currentStep.step === 'officialCarList' ||
        rootState.currentStep.step === 'fixedEquipmentList' ||
        tabLabel === '移动机械' ||
        tabLabel === '固定机械' ||
        tabLabel === '固定设备'
      var queryValues = {
        orgUid:
          (data && data.orgUid) ||
          pageQuery.orgUid ||
          (rootState.queryValues.officialCar &&
            rootState.queryValues.officialCar.orgUid) ||
          rootState.user.orgValue,
        laborCompanyUid:
          (data && data.laborCompanyUid) || pageQuery.laborCompanyUid || '',
        onlyCurrent: ''
      }
      const forSelect = !!(data && data.forSelect)
      if (forSelect) {
        if (isEnterpriseDirectValue(data.vprojectUid)) {
          queryValues.orgUid = rootState.user.orgValue
          queryValues.onlyCurrent = '1'
        } else if (data.vprojectUid) {
          queryValues.orgUid = data.vprojectUid
        }
        queryValues.deviceCategory = data.deviceCategory || '移动机械'
        queryValues.carUsage = data.carUsage || ''
        queryValues.query = data.query || ''
        queryValues.page = data.page || 1
        queryValues.limit = data.limit || 500
        // 在场车辆：与后端 onSite=1（exit=false）对齐
        if (data.onSite != null && data.onSite !== '') {
          queryValues.onSite = data.onSite
        } else {
          queryValues.onSite = '1'
        }
      } else if (isDeviceListPage) {
        if (isEnterpriseDirectValue(pageQuery.vprojectUid)) {
          queryValues.orgUid = rootState.user.orgValue
          queryValues.onlyCurrent = '1'
        } else if (pageQuery.vprojectUid) {
          queryValues.orgUid = pageQuery.vprojectUid
        }
        queryValues.deviceCategory = isFixedList ? '固定设备' : '移动机械'
        queryValues.query = (data && data.query) || pageQuery.query || ''
        queryValues.carUsage = (data && data.carUsage) || pageQuery.carUsage || ''
        queryValues.year = (data && data.year) || pageQuery.year || ''
        queryValues.hasMonitoring =
          (data && data.hasMonitoring) || pageQuery.hasMonitoring || ''
        queryValues.isExpired =
          (data && data.isExpired) || pageQuery.isExpired || ''
        queryValues.page =
          (data && data.page) || rootState.page[queryKey] || 1
        queryValues.limit =
          (data && data.limit) || rootState.limit[queryKey] || 10
        if (tz) {
          queryValues.inspectSort = '1'
          if (
            pageQuery.inspectExpired === '1' ||
            pageQuery.inspectExpired === '0'
          ) {
            queryValues.inspectExpired = pageQuery.inspectExpired
          }
        } else if (typeof pageQuery.exit === 'boolean') {
          queryValues.onSite = pageQuery.exit ? '1' : '0'
        }
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/car/list',
          data: queryValues
        },
        { root: true }
      )
      if (!res || res.code !== 200) {
        return state.officialCarList
      }
      const payload = res.data
      const paged =
        payload && !Array.isArray(payload) && Array.isArray(payload.result)
      var officialCarList = paged
        ? payload.result
        : Array.isArray(payload)
        ? payload
        : []
      const total = paged
        ? Number(payload.totalSize) || 0
        : officialCarList.length
      officialCarList.forEach((item) => {
        item.value = item.uid
        item.label = item.carCode
        item.disabledButtons = []
        if (item.vprojectUid !== rootState.user.orgValue) {
          item.disabledButtons = ['', 1, 2, '']
          item.isSwitch = true
        } else if (
          !item.monitoringInfo ||
          !item.monitoringInfo.length ||
          item.exit
        ) {
          item.disabledButtons = ['', '', '', 3]
        }
        item.allowPenson = item.approvedPenson
        item.approvedPenson = item.approvedPenson ? item.approvedPenson + '人' : ''
        item.allowSpeed = item.limitSpeed
        item.limitSpeed = item.limitSpeed ? item.limitSpeed + 'km/h' : ''
        item.entryDate = daysFormat(item.entryDate)
        item.exitDate = item.exitDate ? daysFormat(item.exitDate) : ''
        if (tz) {
          item.isSwitch = true
        } else {
          item.isSwitch = item.exit
          if (!item.exit) {
            item.exitDate = '未退场'
          }
        }
        if (tz && !item.carUsage) {
          item.carUsage = '燃油运输'
        }
        item.laborCompanyName = item.laborCompanyName
          ? item.laborCompanyName
          : '项目标段用车'
        item.isExpired = !item.insuranceExpiryDate
          ? '未备案'
          : item.insuranceExpiryDate &&
            item.insuranceExpiryDate < daysFormat(new Date())
          ? '已过期'
          : '未过期'
        item.insuranceExpiryDate = !item.insuranceExpiryDate
          ? '/'
          : daysFormat(item.insuranceExpiryDate)
        item.dayInterval = !item.latestMaintainDate
          ? Infinity
          : getDayInterval(item.dayInterval)
        item.latestMaintainDate = !item.latestMaintainDate
          ? '/'
          : daysFormat(item.latestMaintainDate)
        item.nextMaintainDate = !item.nextMaintainDate
          ? '没有日期'
          : daysFormat(item.nextMaintainDate)
        item.maintainExpired =
          item.nextMaintainDate === '没有日期' ||
          item.nextMaintainDate < daysFormat(new Date())
        if (tz) {
          item.inspectExpired = item.maintainExpired
        }
        item.monitoringInfo =
          item.monitoringInfo && item.monitoringInfo.length
            ? getDistinct(item.monitoringInfo).join('|')
            : '无监控设备'
        item.paramJson = item.paramJson ? item.paramJson : []
        item.paramJson.forEach((param) => {
          param.info =
            param.label + '：' + param.value + (param.unit ? param.unit : '')
        })
        item.paramJsonInfo = getSameAttribute(
          item.paramJson,
          'info',
          '；'
        ).joinString
        item.paramJsonInfo = item.paramJsonInfo ? item.paramJsonInfo : '/'
        item.carName = item.carName || item.carCode
      })
      if (!forSelect) {
        dispatch('getCarMonitoringList')
      }
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'officialCarList',
          value: officialCarList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'officialCarTotal',
          value: total
        },
        { root: true }
      )
      return officialCarList
    },
    // 获取工程用车监控列表
    async getCarMonitoringList({ commit, dispatch }) {
      const zhbdCarList = await dispatch('getZhbdCarList', {}, { root: true })
      const carList = zhbdCarList
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'carList',
          value: carList
        },
        { root: true }
      )
      return carList
    },
    // 获取工程用车监控详情
    async getMonitorInfo({ getters, commit, dispatch }) {
      const carIds = getSameAttribute(getters.hasMonitor, 'carId').joinString
      const zhbdCarList = await dispatch('getZhbdPositionById', carIds, {
        root: true
      })
      const carList = zhbdCarList
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'carList',
          value: carList
        },
        { root: true }
      )
      return carList
    },
    // 获取工程用车信息
    async getOfficialCarEnterInfo(
      { state, rootState, rootGetters, commit, dispatch },
      uid
    ) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/car/entry',
          data: { uid: uid ? uid : state.officialCarInfo.uid }
        },
        { root: true }
      )
      var officialCarInfo = res.data ? res.data : {}
      const tz = isTzInspectionSession(rootGetters)
      officialCarInfo.carName =
        officialCarInfo.carName || officialCarInfo.carCode
      officialCarInfo.deviceCategory =
        officialCarInfo.deviceCategory || '移动机械'
      officialCarInfo.entryDate = daysFormat(officialCarInfo.entryDate)
      officialCarInfo.exitDate = officialCarInfo.exit
        ? daysFormat(officialCarInfo.exitDate)
        : ''
      if (tz) {
        if (!officialCarInfo.driverName) {
          officialCarInfo.driverName = '甘肃省特种设备检验检测研究院'
        }
        if (!officialCarInfo.carUsage) {
          officialCarInfo.carUsage = '燃油运输'
        }
      }
      officialCarInfo.laborCompanyName = officialCarInfo.laborCompanyName
        ? officialCarInfo.laborCompanyName
        : '项目标段用车'
      officialCarInfo.laborCompany = {
        value: officialCarInfo.laborCompanyUid,
        label: officialCarInfo.laborCompanyName
      }
      officialCarInfo.fileLists = {
        vehicleLicense: []
      }
      attachVehicleLicense(officialCarInfo, commit, rootState)
      officialCarInfo.insuranceList = officialCarInfo.insuranceList
        ? officialCarInfo.insuranceList
        : []
      officialCarInfo.insuranceList.forEach((item) => {
        item.fileLists = {
          policyImage: []
        }
        if (item.policyImage && item.policyImage.length) {
          commit(
            'pictureSet',
            { key: 'policyImage', value: item.policyImage },
            { root: true }
          )
          item.fileLists.policyImage = rootState.pictures.policyImage
        }
        item.srcList = getSameAttribute(
          item.fileLists.policyImage,
          'url'
        ).values
        item.policyImageInfo =
          item.policyImage && item.policyImage.length
            ? item.policyImage.length + '张保单图片'
            : '无保单图片'
      })
      officialCarInfo.maintainList = officialCarInfo.maintainList
        ? officialCarInfo.maintainList
        : []
      officialCarInfo.maintainList.forEach((item) => {
        item.fileLists = {
          maintenanceDocument: []
        }
        if (item.maintenanceDocument && item.maintenanceDocument.length) {
          commit(
            'pictureSet',
            { key: 'maintenanceDocument', value: item.maintenanceDocument },
            { root: true }
          )
          item.fileLists.maintenanceDocument =
            rootState.pictures.maintenanceDocument
        }
        item.srcList = getSameAttribute(
          item.fileLists.maintenanceDocument,
          'url'
        ).values
        item.maintenanceDocumentInfo =
          item.maintenanceDocument && item.maintenanceDocument.length
            ? item.maintenanceDocument.length + '张维修保养单据'
            : '无维修保养单据'
      })
      officialCarInfo.deviceList = officialCarInfo.deviceList
        ? officialCarInfo.deviceList
        : []
      officialCarInfo.deviceList.forEach((item) => {
        item.monitoredEntityName = officialCarInfo.carCode
        item.deviceUid = item.uid
      })
      commit(
        'baseSet',
        {
          module: 'officialCar',
          key: 'officialCarInfo',
          value: officialCarInfo
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'insurance',
          key: 'insuranceList',
          value: officialCarInfo.insuranceList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'maintenance',
          key: 'maintainList',
          value: officialCarInfo.maintainList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'device',
          key: 'deviceList',
          value: officialCarInfo.deviceList
        },
        { root: true }
      )
      return officialCarInfo
    }
  }
}
